<template>
  <div class="app-container">
    <div class="img">
      <img src="../../assets/img/new_active.jpg" alt="" srcset="" />
      <div class="btn1" @click="toDevice(0, 2)">
        <img src="../../assets/img/new_btn1.png" alt="" />
      </div>
      <div class="btn2" @click="toDevice(2, 3)">
        <img src="../../assets/img/new_btn1.png" alt="" />
      </div>
      <div class="btn3" @click="toDevice(1, 10)">
        <img src="../../assets/img/new_btn1.png" alt="" />
      </div>
      <div class="btn4" @click="toDevice(998, 998)">
        <img src="../../assets/img/new_btn1.png" alt="" />
      </div>
      <div class="btn5" @click="toDevice(999, 999)">
        <img src="../../assets/img/new_btn2.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {};
  },
  beforeCreate() {},
  created() {},
  methods: {
    toDevice(type, id) {
      if (type === 998) {
        this.$message.info("敬请期待")
        return;
      } else if (type === 999) {
        this.openChat();
      } else {
        let obj = this.$store.getters;
        if (obj.token) {
          this.$router.push({
              path: "/appointPage",
              query: {
                id: id,
                type: type,
              },
          });
        } else {
          //去登录
          this.$message.warning("请先登录")
        }
      }
    },
    openChat() {
      console.log(1111);
      // globalVisitHandle.openInitiatedChat(!1)
      // _MICHAT.floatClick()
      window._MICHAT =
        window._MICHAT ||
        function () {
          (_MICHAT.a = _MICHAT.a || []).push(arguments);
        };
      _MICHAT("cptid", "67ba3eae18f2");
      _MICHAT("domain", "emdchk.xianshangkefu.net");
      (function (m, d, q, j, s) {
        (j = d.createElement(q)), (s = d.getElementsByTagName(q)[0]);
        j.async = true;
        j.charset = "UTF-8";
        j.src =
          ("https:" == document.location.protocol ? "https://" : "http://") +
          "emdchk.xianshangkefu.net/Web/JS/mivisit.js?_=t";
        s.parentNode.insertBefore(j, s);
      })(window, document, "script");
      // globalVisitHandle.openInitiatedChat('https://chat56.live800.com/live800/chatClient/chatbox1622974.jspc?companyID=1622974&configID=590199&jid=9350194081&s=1')
    },
  },
};
</script>

<style lang="scss" scoped>
.img {
  position: relative;
  width: 80%;
  margin: 0 auto;
  img {
    width: 100%;
  }
  .btn1 {
    position: absolute;
    right: 17.5%;
    top: 42.9%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
  .btn2 {
    position: absolute;
    left: 20.5%;
    top: 57.4%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
  .btn3 {
    position: absolute;
    right: 17.5%;
    top: 69.3%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
  .btn4 {
    position: absolute;
    left: 20.5%;
    top: 81.6%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
  .btn5 {
    position: absolute;
    right: 17.5%;
    top: 89.2%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
}
</style>
